export default __webpack_public_path__ + "static/media/mata_atlantica.f4e4ceb5.jpg";